(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pth-mobile-menu"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('pth-mobile-menu')) return;

  class PthMobileMenu extends HTMLElement {
    connectedCallback() {
      this._initTimer = window.setTimeout(() => {
        if (this.isConnected && !this._controller) this.init();
      }, 0);
    }

    disconnectedCallback() {
      window.clearTimeout(this._initTimer);
      window.clearTimeout(this._quizTimer);
      window.clearTimeout(this._searchTimer);
      this._fetchController?.abort();
      this.closeNow(false);
      this._controller?.abort();
      this._controller = null;
    }

    init() {
      this.dialog = this.querySelector('.pth-mm__dialog');
      this.panel = this.querySelector('[data-pth-panel]');
      this.scroller = this.querySelector('[data-pth-scroll]');
      if (!this.dialog || !this.panel || typeof this.dialog.showModal !== 'function') return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      const on = (target, name, handler, options = {}) => target.addEventListener(name, handler, { ...options, signal });
      this._media = window.matchMedia('(max-width: 749px)');
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._selector = this.dataset.trigger.trim() || '#Details-menu-drawer-container > summary';
      try { document.querySelector(this._selector); }
      catch (error) { console.warn('[PTH mobile menu] Invalid trigger selector; original menu preserved.', error); return; }
      this._editor = Boolean(window.Shopify && window.Shopify.designMode);
      this._closeTicket = 0;
      this.search = this.querySelector('[data-pth-search]');
      this.suggestions = this.querySelector('[data-pth-suggestions]');
      this.results = this.querySelector('[data-pth-results]');
      this.status = this.querySelector('[data-pth-search-status]');
      this.allResults = this.querySelector('[data-pth-all-results]');

      // Capture only a confirmed click on the existing hamburger, and only on mobile.
      // If anything fails BEFORE opening, default/native behavior is left intact.
      on(window, 'click', event => {
        if (!this._media.matches || this.dataset.enabled !== 'true' || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        const element = event.target instanceof Element ? event.target : event.target?.parentElement;
        const trigger = element?.closest(this._selector);
        if (!trigger || this.contains(trigger)) return;
        const other = document.querySelector('pth-mobile-menu[data-pth-open="true"]');
        if (other && other !== this) return;
        if (trigger.closest('details')?.open) return;
        if (this.openMenu(trigger)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });

      on(this._media, 'change', () => {
        if (!this._media.matches) { window.clearTimeout(this._quizTimer); this.closeNow(false); }
      });
      on(window, 'pagehide', () => { window.clearTimeout(this._quizTimer); this.closeNow(false); });
      on(this.dialog, 'cancel', event => {
        event.preventDefault();
        if (this.suggestions && !this.suggestions.hidden) this.hideSuggestions();
        else this.requestClose();
      });
      on(this.dialog, 'close', () => { if (!this.dialog.open) this.cleanup(this._returnFocus !== false); });
      on(this.dialog, 'pointerdown', event => { this._backdropDown = event.target === this.dialog; });
      on(this.dialog, 'click', event => {
        const element = event.target instanceof Element ? event.target : null;
        if (element?.closest('[data-pth-close]') || (event.target === this.dialog && this._backdropDown)) {
          event.preventDefault(); this.requestClose(); return;
        }
        const toggle = element?.closest('[data-pth-toggle]');
        if (toggle) {
          const target = document.getElementById(toggle.getAttribute('aria-controls'));
          if (target && this.contains(target)) {
            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!expanded));
            target.hidden = expanded;
          }
          return;
        }
        const link = element?.closest('a[href]');
        if (link?.hasAttribute('data-pth-menu-quiz') && link.target !== '_blank' && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          event.preventDefault();
          this.chooseFromMenu(link);
          return;
        }
        if (link && link.target !== '_blank' && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) this.closeNow(false);
      });
      on(this.dialog, 'keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault(); event.stopPropagation();
        if (this.suggestions && !this.suggestions.hidden) {
          this.hideSuggestions(); this.search?.focus({ preventScroll: true });
        } else this.requestClose();
      });

      if (this.search) {
        on(this.search, 'input', () => this.scheduleSearch());
        on(this.search, 'keydown', event => {
          if (event.key === 'ArrowDown' && this.suggestions && !this.suggestions.hidden) {
            const first = this.suggestions.querySelector('a');
            if (first) { event.preventDefault(); first.focus(); }
          }
        });
        on(this.querySelector('[data-pth-search-form]'), 'submit', () => this.closeNow(false));
        on(this.suggestions, 'keydown', event => {
          if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
          const links = [...this.suggestions.querySelectorAll('a')];
          const index = links.indexOf(document.activeElement);
          if (index < 0) return;
          event.preventDefault();
          const next = index + (event.key === 'ArrowDown' ? 1 : -1);
          if (next < 0) this.search.focus();
          else links[Math.min(next, links.length - 1)]?.focus();
        });
        on(this.dialog, 'pointerdown', event => {
          if (!event.target.closest('.pth-mm__search-wrap')) this.hideSuggestions();
        });
      }

      // This query parameter is an explicit, mobile-only navigation request.
      // No cookies, session storage or changes to the original quiz section.
      this.querySelectorAll('[data-pth-menu-quiz]').forEach(link => {
        const destination = this.quizLandingUrl(link.href);
        if (destination) link.href = destination.href;
      });
      const resume = () => this.resumeChooser(0);
      if (document.readyState === 'loading') on(document, 'DOMContentLoaded', resume, { once: true });
      else this._quizTimer = window.setTimeout(resume, 0);

      if (this._editor) {
        on(document, 'shopify:section:select', event => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.openMenu(null);
          else this.closeNow(false);
        });
        on(document, 'shopify:block:select', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          if (!this.openMenu(null)) return;
          const block = [...this.querySelectorAll('[data-pth-block]')].find(item => item.dataset.pthBlock === event.detail.blockId);
          if (block && this.scroller) {
            const y = block.getBoundingClientRect().top - this.scroller.getBoundingClientRect().top + this.scroller.scrollTop - 12;
            this.scroller.scrollTop = Math.max(0, y);
          }
        });
        if (this.dataset.editorPreview === 'true') this.openMenu(null);
      }
    }

    quizLandingUrl(value) {
      try {
        const destination = new URL(value || this.dataset.homeUrl || '/', window.location.origin);
        if (!['http:', 'https:'].includes(destination.protocol)) return null;
        if (destination.origin === window.location.origin) {
          destination.searchParams.set('pth_choose', '1');
          const current = new URL(window.location.href);
          // Keep the merchant on the same theme preview when navigating to home.
          for (const key of ['preview_theme_id', '_fd', 'pb']) {
            if (current.searchParams.has(key) && !destination.searchParams.has(key)) {
              destination.searchParams.set(key, current.searchParams.get(key));
            }
          }
        }
        return destination;
      } catch (_) { return null; }
    }

    findChooser() {
      // Verified integration with the existing ParaTuHome-Descubre section.
      // Never trigger arbitrary links or open an uninitialized dialog directly.
      for (const root of document.querySelectorAll('.pth-descubre[data-quiz-init="1"]')) {
        if (this.contains(root) || !root.getClientRects().length) continue;
        const opener = root.querySelector('[data-pth-quiz-open]');
        const dialog = root.querySelector('.pth-descubre__quiz');
        if (opener && !opener.disabled && dialog && typeof dialog.showModal === 'function') {
          return { opener, dialog };
        }
      }
      return null;
    }

    openChooser() {
      if (!this._media?.matches || this.dataset.enabled !== 'true') return false;
      const chooser = this.findChooser();
      if (!chooser) return false;
      // Release our scroll lock BEFORE the existing quiz records its own state.
      this.closeNow(false);
      if (chooser.dialog.open) return true;
      const html = document.documentElement;
      const oldOverflow = html.style.getPropertyValue('overflow');
      const oldPriority = html.style.getPropertyPriority('overflow');
      try { chooser.opener.click(); }
      catch (error) { console.warn('[PTH mobile menu] Existing chooser could not open.', error); }
      if (chooser.dialog.open) return true;
      // A broken third-party handler must not leave the page scroll-locked.
      if (oldOverflow) html.style.setProperty('overflow', oldOverflow, oldPriority);
      else html.style.removeProperty('overflow');
      return false;
    }

    showChooserUnavailable() {
      if (!this._media?.matches || this.dataset.enabled !== 'true') return;
      this.openMenu(null);
      const status = this.querySelector('[data-pth-action-status]');
      if (!status) return;
      status.textContent = 'El asistente no est\u00e1 disponible en esta p\u00e1gina. Puedes explorar las categor\u00edas o escribirnos en Contacto.';
      status.hidden = false;
      status.tabIndex = -1;
      status.focus({ preventScroll: true });
      if (this.scroller) {
        const y = status.getBoundingClientRect().top - this.scroller.getBoundingClientRect().top + this.scroller.scrollTop - 12;
        this.scroller.scrollTop = Math.max(0, y);
      }
    }

    chooseFromMenu(link) {
      if (!this._media?.matches || this.dataset.enabled !== 'true') return;
      const status = this.querySelector('[data-pth-action-status]');
      if (status) status.hidden = true;
      if (this.openChooser()) return;
      const destination = this.quizLandingUrl(link.href);
      const current = new URL(window.location.href);
      const normalize = path => path.replace(/\/+$/, '') || '/';
      if (destination && (destination.origin !== current.origin || normalize(destination.pathname) !== normalize(current.pathname))) {
        this.closeNow(false);
        window.location.assign(destination.href);
      } else this.showChooserUnavailable();
    }

    clearChooserRequest() {
      try {
        const url = new URL(window.location.href);
        if (url.searchParams.get('pth_choose') !== '1') return;
        url.searchParams.delete('pth_choose');
        window.history.replaceState(window.history.state, '', url.href);
      } catch (_) { /* A restricted preview must not break ordinary navigation. */ }
    }

    resumeChooser(attempt) {
      if (!this.isConnected || !this._controller || !this._media?.matches || this.dataset.enabled !== 'true') return;
      const url = new URL(window.location.href);
      if (url.searchParams.get('pth_choose') !== '1') return;
      if (this.openChooser()) { this.clearChooserRequest(); return; }
      if (attempt < 15) {
        this._quizTimer = window.setTimeout(() => this.resumeChooser(attempt + 1), 150);
      } else {
        this.clearChooserRequest();
        this.showChooserUnavailable();
      }
    }

    duration() {
      return this._motion?.matches ? 0 : Math.max(0, Math.min(400, Number(this.dataset.duration) || 0));
    }

    openMenu(trigger) {
      if (!this._media?.matches || this.dataset.enabled !== 'true' || !this.isConnected) return false;
      if (this.dialog.open) return true;
      this._returnFocus = true;
      this._trigger = trigger || null;
      this._previousFocus = document.activeElement;
      try {
        this.dialog.showModal();
        this.lockScroll();
        this.dataset.pthOpen = 'true';
        this._closing = false;
        if (trigger) {
          this._triggerAttributes = ['aria-controls', 'aria-haspopup', 'aria-expanded'].map(name => [name, trigger.getAttribute(name)]);
          // Do not set aria-expanded=true: the original theme uses it to draw its overlay.
          trigger.setAttribute('aria-controls', this.dialog.id || (this.dialog.id = `${this.id}-dialog`));
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.removeAttribute('aria-expanded');
        }
        this.scroller.scrollTop = 0;
        this.querySelector('[data-pth-close]')?.focus({ preventScroll: true });
        this._animation?.cancel();
        if (this.duration() && typeof this.panel.animate === 'function') {
          this._animation = this.panel.animate(
            [{ transform: `translateX(${this.dataset.side === 'right' ? '100%' : '-100%'})` }, { transform: 'translateX(0)' }],
            { duration: this.duration(), easing: 'cubic-bezier(.2,.7,.2,1)' }
          );
        }
        return true;
      } catch (error) {
        this.closeNow(false);
        console.warn('[PTH mobile menu] Could not open; original menu preserved.', error);
        return false;
      }
    }

    requestClose() {
      if (!this.dialog?.open || this._closing) return;
      this._closing = true;
      const ticket = ++this._closeTicket;
      this._animation?.cancel();
      if (!this.duration() || typeof this.panel.animate !== 'function') { this.closeNow(true); return; }
      this._animation = this.panel.animate(
        [{ transform: 'translateX(0)' }, { transform: `translateX(${this.dataset.side === 'right' ? '100%' : '-100%'})` }],
        { duration: Math.min(this.duration(), 200), easing: 'ease-in', fill: 'forwards' }
      );
      this._animation.finished.catch(() => {}).then(() => { if (ticket === this._closeTicket) this.closeNow(true); });
    }

    closeNow(restoreFocus = true) {
      this._closeTicket = (this._closeTicket || 0) + 1;
      this._returnFocus = restoreFocus;
      this._animation?.cancel();
      this._animation = null;
      this._closing = false;
      if (this.dialog?.open) this.dialog.close();
      this.cleanup(restoreFocus);
    }

    cleanup(restoreFocus) {
      const wasOpen = this.dataset.pthOpen === 'true';
      delete this.dataset.pthOpen;
      window.clearTimeout(this._searchTimer);
      this._fetchController?.abort();
      this.hideSuggestions();
      this.unlockScroll();
      if (this._trigger && this._triggerAttributes) {
        for (const [name, value] of this._triggerAttributes) {
          if (value === null) this._trigger.removeAttribute(name);
          else this._trigger.setAttribute(name, value);
        }
      }
      const target = this._trigger || this._previousFocus;
      this._triggerAttributes = null;
      this._trigger = null;
      this._previousFocus = null;
      if (wasOpen && restoreFocus && target?.isConnected && target.getClientRects().length) target.focus({ preventScroll: true });
    }

    lockScroll() {
      if (this._scrollLock) return;
      const elements = [document.documentElement, document.body];
      const properties = ['overflow', 'overscroll-behavior'];
      this._scrollLock = elements.map(element => ({
        element, hadStyle: element.hasAttribute('style'),
        properties: properties.map(name => [name, element.style.getPropertyValue(name), element.style.getPropertyPriority(name)])
      }));
      for (const element of elements) {
        element.style.setProperty('overflow', 'hidden');
        element.style.setProperty('overscroll-behavior', 'none');
      }
    }

    unlockScroll() {
      if (!this._scrollLock) return;
      for (const record of this._scrollLock) {
        for (const [name, value, priority] of record.properties) {
          if (value) record.element.style.setProperty(name, value, priority);
          else record.element.style.removeProperty(name);
        }
        if (!record.hadStyle && !record.element.getAttribute('style')?.trim()) record.element.removeAttribute('style');
      }
      this._scrollLock = null;
    }

    hideSuggestions() {
      window.clearTimeout(this._searchTimer);
      this._fetchController?.abort();
      if (this.suggestions) this.suggestions.hidden = true;
      if (this.status) this.status.textContent = '';
    }

    scheduleSearch() {
      window.clearTimeout(this._searchTimer);
      this._fetchController?.abort();
      const query = this.search.value.trim();
      this.hideSuggestions();
      if (this.dataset.predictive !== 'true' || query.length < 2 || !this.dialog.open) return;
      this._searchTimer = window.setTimeout(() => this.fetchSuggestions(query), 240);
    }

    async fetchSuggestions(query) {
      const controller = new AbortController();
      this._fetchController = controller;
      try {
        const endpoint = new URL(this.dataset.searchEndpoint || '/search/suggest', window.location.origin);
        if (endpoint.origin !== window.location.origin) return;
        if (!endpoint.pathname.endsWith('.json')) endpoint.pathname += '.json';
        endpoint.searchParams.set('q', query);
        endpoint.searchParams.set('resources[type]', 'product');
        endpoint.searchParams.set('resources[limit]', '4');
        endpoint.searchParams.set('resources[options][unavailable_products]', 'hide');
        const response = await fetch(endpoint.href, { signal: controller.signal, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Search HTTP ${response.status}`);
        const data = await response.json();
        if (!this.dialog.open || controller.signal.aborted || this.search.value.trim() !== query) return;
        const products = Array.isArray(data?.resources?.results?.products) ? data.resources.results.products.slice(0, 4) : [];
        this.results.replaceChildren();
        let rendered = 0;
        for (const product of products) {
          if (typeof product.url !== 'string' || typeof product.title !== 'string') continue;
          const url = new URL(product.url, window.location.origin);
          if (url.origin !== window.location.origin || !['http:', 'https:'].includes(url.protocol)) continue;
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.className = 'pth-mm__result'; link.href = url.href;
          const imageSource = typeof product.featured_image?.url === 'string' ? product.featured_image.url : product.image;
          if (typeof imageSource === 'string' && imageSource) {
            const imageUrl = new URL(imageSource, window.location.origin);
            if (['http:', 'https:'].includes(imageUrl.protocol)) {
              const image = document.createElement('img');
              image.src = imageUrl.href; image.alt = ''; image.width = 42; image.height = 42; image.loading = 'lazy';
              link.append(image);
            }
          }
          const title = document.createElement('span'); title.textContent = product.title;
          link.append(title); li.append(link); this.results.append(li); rendered += 1;
        }
        const allUrl = new URL(this.dataset.searchUrl || '/search', window.location.origin);
        allUrl.searchParams.set('q', query); allUrl.searchParams.set('type', 'product'); allUrl.searchParams.set('options[prefix]', 'last');
        this.allResults.href = allUrl.href;
        this.suggestions.hidden = false;
        this.status.textContent = rendered ? `${rendered} sugerencias. Usa Tab o flecha abajo para verlas.` : 'Sin sugerencias. Puedes buscar en toda la tienda.';
      } catch (error) {
        if (error.name !== 'AbortError') this.hideSuggestions();
        // The ordinary Shopify search form always remains available.
      }
    }
  }
  customElements.define('pth-mobile-menu', PthMobileMenu);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pth-results-animated')) {
    customElements.define('pth-results-animated', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-percentage]'));
        this.items.forEach(item => {
          const svg = item.querySelector('[data-gradient]');
          if (svg && svg.dataset.circleColor === 'gradient') {
            const colors = svg.dataset.gradient.match(/#[0-9a-f]{3,8}\b|rgba?\([^)]*\)|hsla?\([^)]*\)/gi);
            if (colors && colors.length > 1) {
              const stops = svg.querySelectorAll('stop');
              stops[0].setAttribute('stop-color', colors[0]);
              stops[1].setAttribute('stop-color', colors[colors.length - 1]);
            }
          }
        });
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.items.forEach(item => this.updateItem(item, 0));
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.timer = setTimeout(() => this.animateItems(), Number(this.dataset.delay) || 0);
          }
        }, { threshold: .15 });
        this.observer.observe(this);
      }
      updateItem(item, progress) {
        const target = Number(item.dataset.percentage) || 0;
        const value = Math.round(target * progress);
        const label = item.querySelector('.results__percentage-label') || item.querySelector('p');
        if (label) label.textContent = value + '%';
        item.style.setProperty('--percentage', value + '%');
        const ring = item.querySelector('.ring__prog');
        if (ring) { ring.style.transition = 'none'; ring.setAttribute('stroke-dasharray', value + ' 100'); }
        const fillRect = item.querySelector('.pth-result-iconfill-rect');
        if (fillRect) {
          const height = 24 * (value / 100);
          fillRect.setAttribute('y', String(24 - height));
          fillRect.setAttribute('height', String(height));
        }
      }
      animateItems() {
        const start = performance.now();
        const duration = Number(this.dataset.duration) || 650;
        const tick = now => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.items.forEach(item => this.updateItem(item, eased));
          if (progress < 1) this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      disconnectedCallback() { this.observer?.disconnect(); clearTimeout(this.timer); cancelAnimationFrame(this.frame); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
